import { css } from '@emotion/react';
import { breakpoints } from 'style';

export const message = css`
  grid-column: 2 / span 10;

  font-family: var(--font-family-secondary);
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-small);
  line-height: var(--line-height-small);

  padding: calc(var(--unit) * 35) 0 calc(var(--unit) * 20);

  @media ${breakpoints.medium} {
    font-size: var(--font-size-large);
    line-height: var(--line-height-large);
  }
`;
